import dynamic from "next/dynamic";
import React, { useState } from "react";
import Sites from "../../constants/Sites";
import styles from "./SingleColumnLayout.module.css";
import { useTabletDetection } from "helpers/useTabletDetection";
import { shouldShowFloatingMenu } from "helpers/Helper";

import "./GlobalLayout1.css";
import EBBMenu from "@components/Header/EBBMenu/EBBMenu";
import EBBBottomNav from "@components/Header/EBBBottomNav/EBBBottomNav";
import ContentHeader from "@components/HeaderPage/ContentHeader";
import CatalogHeader from "@components/HeaderPage/CatalogHeader";

//Dynamic import based on https://github.com/zeit/next.js/blob/canary/examples/with-dynamic-import/pages/index.js
// {/ Load immediately, but in a separate bundle / }
const Header = dynamic(() => import("../Header/Header"));
const Footer = dynamic(() => import("../Footer"));
const NewHeader = dynamic(() => import("../Header/NewHeader"));

const SingleColumnLayout = (props) => {
  const {
    siteId,
    isMobile,
    isNonClosableModalChecked,
    isTablet: serverIsTablet,
    postType,
    isSimilarTitlesPage,
    hideSiteChrome = false,
    hideNewsletter = false,
  } = props || {};
  const [activeBottomNavIndex, setActiveBottomNavIndex] = useState(null);

  // Enhanced client-side tablet detection using custom hook
  const { isTablet } = useTabletDetection(serverIsTablet, isMobile);

  const isHeader = parseInt(siteId) === Sites.EARLYBIRDBOOKS ? false : true;
  const handleBottomNavChange = (idx) => {
    setActiveBottomNavIndex(idx);
  };

  const handleMenuClose = () => {
    setActiveBottomNavIndex(null);
  };

  // Check if floating menu should be shown based on post type and device
  const showFloatingMenu = shouldShowFloatingMenu(postType, isMobile, isTablet);
  return (
    <React.Fragment>
      {!hideSiteChrome &&
        (isHeader ? (
          <>
            <Header isNonClosableModalChecked={isNonClosableModalChecked} />
            {!isMobile && !isTablet && siteId !== Sites.OPENROADMEDIA && (
              <ContentHeader isMobile={isMobile} isTablet={isTablet} />
            )}
            {!isMobile && siteId === Sites.OPENROADMEDIA && <CatalogHeader />}
          </>
        ) : (
          <>
            <NewHeader
              activeBottomNavIndex={activeBottomNavIndex}
              onMenuClose={handleMenuClose}
              isNonClosableModalChecked={isNonClosableModalChecked}
            />
            {!isMobile && !isTablet && <EBBMenu />}
            {(isMobile || isTablet) && showFloatingMenu ? (
              <EBBBottomNav activeBottomNavIndex={handleBottomNavChange} />
            ) : null}
          </>
        ))}
      <div
        className={[
          styles["container_singleColumn"],
          "container_singleColumn",
          isSimilarTitlesPage ? styles.similarTitlesLayout : "",
          hideSiteChrome ? styles.learnMoreLayout : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {props.children}
      </div>
      <Footer hideNewsletter={hideNewsletter} />
    </React.Fragment>
  );
};

export default SingleColumnLayout;
